import React, { useState } from "react";
import { FaCopy, FaRupeeSign, FaWallet, FaWhatsapp } from "react-icons/fa";
import { toast } from "react-toastify";

const DepositPage = () => {
  const [amount, setAmount] = useState("");
  const quickAmounts = [100, 500, 1000, 2000, 5000, 10000];
  const upiId = "payment@cr11";

  const handleCopy = () => {
    navigator.clipboard.writeText(upiId);
    toast.success("UPI ID copied!");
  };

  return (
    <div className="min-h-screen bg-gray-900 pb-20">
      <div className="bg-gradient-to-b from-green-900/50 via-gray-900 to-gray-900 pt-6 pb-8">
        <div className="max-w-lg mx-auto px-4">
          <h1 className="text-2xl font-bold text-white mb-6">Deposit Funds</h1>

          {/* Amount Input Section */}
          <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700/50 rounded-xl p-6">
            <label className="block text-gray-400 text-sm font-medium mb-2">
              Enter Amount
            </label>
            <div className="relative">
              <FaRupeeSign className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                className="w-full pl-10 pr-4 py-3 bg-gray-700 text-white rounded-lg border border-gray-600 focus:border-green-500 focus:ring-1 focus:ring-green-500"
                placeholder="Enter amount"
                min="100"
                max="50000"
              />
            </div>

            {/* Quick Amount Buttons */}
            <div className="grid grid-cols-3 gap-2 mt-4">
              {quickAmounts.map((amt) => (
                <button
                  key={amt}
                  onClick={() => setAmount(amt)}
                  className="bg-gray-700/50 text-gray-300 py-2 px-4 rounded-lg border border-gray-600 hover:bg-gray-700 transition-colors"
                >
                  ₹{amt}
                </button>
              ))}
            </div>
          </div>

          {/* UPI Payment Section */}
          <div className="mt-6 bg-gray-800/50 backdrop-blur-sm border border-gray-700/50 rounded-xl p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg font-semibold text-white">UPI Payment</h2>
              <FaWallet className="text-green-500" />
            </div>

            <div className="bg-gray-700/50 p-4 rounded-lg mb-4">
              <p className="text-sm text-gray-400 mb-2">UPI ID</p>
              <div className="flex items-center justify-between bg-gray-800 p-3 rounded-lg">
                <span className="text-white font-mono">{upiId}</span>
                <button
                  onClick={handleCopy}
                  className="text-green-400 hover:text-green-300 transition-colors"
                >
                  <FaCopy />
                </button>
              </div>
            </div>

            <div className="space-y-4">
              <button className="w-full bg-gradient-to-r from-green-600 to-green-500 text-white py-4 rounded-xl font-medium hover:from-green-500 hover:to-green-400 transition-all flex items-center justify-center gap-2 shadow-lg shadow-green-900/20">
                Pay Now
              </button>

              <button className="w-full bg-gray-800 text-white py-4 rounded-xl font-medium hover:bg-gray-700 transition-all flex items-center justify-center gap-2">
                <FaWhatsapp className="text-green-400" />
                Contact Support
              </button>
            </div>

            <p className="mt-4 text-xs text-gray-400">
              *Minimum deposit: ₹100 | Maximum deposit: ₹50,000
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepositPage;
